module.exports = __webpack_public_path__ + "img/12.0b532ab2.png";